import React from 'react';
import block from 'bem-cn-lite';
import {FileText, Xmark} from '@gravity-ui/icons';
import {Button, Icon, Text} from '@gravity-ui/uikit';

import './DocumentNotificationToast.scss';

const b = block('document-notification-toast');

type Props = {
    title: string;
    description: string;
    onOpen: () => void;
    onClose: () => void;
};

export const DocumentNotificationToast: React.FC<Props> = ({
    title,
    description,
    onOpen,
    onClose
}) => {
    return (
        <div className={b()}>
            <Icon data={FileText} size={24} />

            <div className={b('content')}>
                <Text variant="subheader-3">{title}</Text>

                <Text variant="body-2" color="complementary">
                    {description}
                </Text>

                <div className={b('actions')}>
                    <Button
                        view="action"
                        size="l"
                        type="button"
                        onClick={onOpen}
                        className={b('actions-button')}
                    >
                        Смотреть
                    </Button>

                    <Button
                        view="outlined"
                        size="l"
                        type="button"
                        onClick={onClose}
                        className={b('actions-button')}
                    >
                        Ок, позже
                    </Button>
                </div>
            </div>

            <Button view="flat" size="s" type="button" onClick={onClose}>
                <Icon data={Xmark} size={16} className={b('close-icon')} />
            </Button>
        </div>
    );
};
